
// Angular
import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// 3rdparty
import dayjs from 'dayjs';

// Hostware
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { DateSelectorComponent } from '@app/components/date-selector/date-selector.component';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { DocumentReadModes } from '@app/enums/DocumentReadModes';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import DateHelper from '@app/helpers/DateHelper';
import HwUtils from '@app/helpers/HwUtils';
import LocalStorage from '@app/helpers/LocalStorage';
import SessionStorage from '@app/helpers/SessionStorage';
import { Country } from '@app/interfaces/Country';
import { GenericMessage } from '@app/interfaces/generic-message';
import { GroupVizaData } from '@app/interfaces/GroupVizaData';
import { VizaData, VizaPart } from '@app/interfaces/VizaData';
import { ZiplCodes } from '@app/interfaces/ZipCodes';
import { LoadCsvService } from '@app/services/loadCsv.service';
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { SpinnerService } from '@app/services/spinner.service';
import { VizaDataService } from '@app/services/viza-data.service';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, combineLatest, debounceTime, firstValueFrom } from 'rxjs';
import { GuestDataFields } from '../../../../../froexishared/src/dto/GuestdataFields';
import { SubscriberParameter } from '../../../../../froexishared/src/dto/SubscriberParameter';
import { SubscriberParameterService } from '../../../../../froexishared/src/services/SubscriberParameter.service';
import { ReservationService } from '@app/services/reservation.service';

@Component({
  selector: 'viza-data',
  templateUrl: './viza-data.component.html',
  styleUrls: ['./viza-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VizaDataComponent implements OnInit, AfterViewInit {

  @ViewChild('dateOfEntry') dateOfEntryComponent: DateSelectorComponent;
  @ViewChild('birthDate') birthDateComponent: DateSelectorComponent;
  @ViewChild('documentType') documentType: MatSelect;

  commonGroup: FormGroup;
  visaRequiredGroup: FormGroup;
  acceptConditionsGroup: FormGroup;
  addressGroup: FormGroup;
  countries: Country[] = [];
  zipCodes: ZiplCodes[] = [];
  dataFields: GuestDataFields[] = [];
  loaded: boolean;
  hasAdditionalDataFields: boolean;
  // VIP tablet mód: a recepción beolvasott okmányadat (RPC), MRZ hiányában ScannedData-ként megy vissza
  vipScannedData: VizaPart;
  birthDate: string;
  title: string;
  today = dayjs().format("YYYYMMDD");
  dateOfEntry: string;
  filteredCountry: Country[] = [];
  mrzCcontrols: MrzControl[] = [
    { ControlName: 'FirstName', Touched: false },
    { ControlName: 'LastName', Touched: false },
    { ControlName: 'DocumentId', Touched: false },
    { ControlName: 'BirthDate', Touched: false },
    { ControlName: 'DocumentType', Touched: false }

  ]

  loadSubscriberParameter$: Subscription;
  modalVisible: boolean = false;

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0

  constructor(
    private fb: FormBuilder,
    private vizaDataService: VizaDataService,
    private router: Router,
    private spinnerService: SpinnerService,
    private subscriberParameterService: SubscriberParameterService,
    private loadCsvService: LoadCsvService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private chatService: ChatService,
    public sessionstoregeService: SessionstorageService,
    private reservationService: ReservationService
  ) {
    this.commonGroup = this.fb.group({
      BirthDate: new FormControl('', [Validators.required, dateValidator]),
      FirstName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      LastName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      FirstNameAtBirth: new FormControl('', [Validators.maxLength(50)]),
      LastNameAtBirth: new FormControl('', [Validators.maxLength(50)]),
      BirthPlace: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      Nationality: new FormControl('', Validators.required),
      MothersFirstName: new FormControl('', [Validators.maxLength(50)]),
      MothersLastName: new FormControl('', [Validators.maxLength(50)]),
      DocumentType: new FormControl('', Validators.required),
      DocumentId: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      Sex: new FormControl('', Validators.required)

    })

    this.visaRequiredGroup = this.fb.group({
      VizaNumber: new FormControl('', Validators.required),
      PlaceOfEntry: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      DateOfEntry: new FormControl('', [Validators.required, dateValidator])
    })

    this.addressGroup = this.fb.group({
      Country: new FormControl('', Validators.required),
      PostalCode: new FormControl('', [Validators.required, Validators.maxLength(10)]),      // min=3 max=10   pattern :=[A-Z0-9][A-Z0-9\s\-]{1,8}[A-Z0-9]
      City: new FormControl('', Validators.maxLength(30)),
      StreetAddress: new FormControl('', [Validators.required, Validators.maxLength(40)])
    })

    this.acceptConditionsGroup = this.fb.group({
      Accept: new FormControl(false)
    })

    if (LocalStorage.IsTabletMode) {
      if (LocalStorage.OperationMode == "VIP") {
        this.title =
          SessionStorage.ActiveGuestHeaderData().RoomTypeName + " - " +
          SessionStorage.ActiveGuestHeaderData().NumberOfGuests + " " + this.translate.instant('common.person') + " - " +
          SessionStorage.ActiveGuestHeaderData().GuestName
      } else {
        this.title = ""
      }
    } else {
      this.title =
        SessionStorage.ActiveGuestHeaderData().RoomTypeName + " - " +
        SessionStorage.ActiveGuestHeaderData().NumberOfGuests + " " + this.translate.instant('common.person') + " - " +
        SessionStorage.ActiveGuestHeaderData().GuestName
    }


  }


  //#region =============== Angular Lifecyle events ============================================================================
  async ngOnInit() {
    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;

      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })

    this.dateOfEntry = this.today.substring(2, 4) + this.today.substring(4, 8)
    if (this.translate.getDefaultLang() === 'hu') {
      this.countries = await firstValueFrom(this.loadCsvService.getDataFromCsv('/assets/data/hu-countries.csv', ";", 'lang'))
    } else {
      this.countries = await firstValueFrom(this.loadCsvService.getDataFromCsv('/assets/data/en-countries.csv', ";", 'lang'))
    }

    this.filteredCountry = [...this.countries];

    this.zipCodes = await firstValueFrom(this.loadCsvService.getDataFromCsv('assets/data/zip-codes.csv', ";", 'zipCode'));

    // this.translate.getDefaultLang() === 'hu' ? this.loadCsvService.getDataFromCsv('assets/data/hu-countries.csv', ";", 'lang') : this.loadCsvService.getDataFromCsv('assets/data/en-countries.csv', ";", this.countries, 'lang');
    // this.filteredCountry = this.countries;
    // setTimeout(() => {
    //   console.log('Executed after 2 seconds');
    // }, 2000);

    // this.loadCsvService.getDataFromCsv('assets/data/zip-codes.csv', ";",  'zipCode');

    combineLatest({
      countryCode: this.addressGroup.get('Country').valueChanges,
      postalCode: this.addressGroup.get('PostalCode').valueChanges
    }).pipe(debounceTime(300))
      .subscribe((result) => {
        if (result.countryCode === 'HUN') {
          if (this.zipCodes.find(zipCode => zipCode.zipCode === result.postalCode)) {
            let filterCity = this.zipCodes.find(zipCode => zipCode.zipCode === result.postalCode).City
            this.addressGroup.get('City').setValue(filterCity)
          }
        }
      })

    // VIP tablet mód: a korábban rögzített vendégadatok előtöltése (az MRZ adat felülírja)
    if (LocalStorage.IsTabletMode && LocalStorage.OperationMode == "VIP") {
      await this.loadVipGuestData()
    }

    if (SessionStorage.MrzData !== undefined) {
      //   form with mrz data
      this.commonGroup.controls["BirthDate"].setValue(SessionStorage.MrzData.DateOfBirth)
      this.commonGroup.controls["FirstName"].setValue(HwUtils.toTitleCase(SessionStorage.MrzData.Surname));
      this.commonGroup.controls["LastName"].setValue(HwUtils.toTitleCase(SessionStorage.MrzData.GivenNames));
      this.commonGroup.controls["Nationality"].setValue(SessionStorage.MrzData.Nationality);
      this.commonGroup.controls["Sex"].setValue(SessionStorage.MrzData.Sex);
      if (SessionStorage.MrzData.DocumentType.includes('TD1') || SessionStorage.MrzData.DocumentType.includes('TD2')) {
        this.commonGroup.controls["DocumentType"].setValue("I")
      }
      if (SessionStorage.MrzData.DocumentType.includes('TD3')) {
        this.commonGroup.controls["DocumentType"].setValue("P")
      }
      this.commonGroup.controls["DocumentId"].setValue(SessionStorage.MrzData.DocumentNumber);
    }

    this.loadSubscriberParameter$ = this.subscriberParameterService.loadAll(HwUtils.getSubscriber(), HwUtils.getHotelId()).subscribe(result => {
      const res = result as SubscriberParameter[]
      const fieldsParameter = res.find(item => item.Param_Typecode == 'DATA_FORM')
      this.dataFields = JSON.parse(fieldsParameter.Param_Json_Value) as GuestDataFields[];

      const loyaltyWarningParam = res.find(item => item.Param_Typecode == 'LOYALTY_WARNING').Param_Int_Value == 0 ? false : true
      if (loyaltyWarningParam) {
        let messageData: GenericMessage = { messageText: this.translate.instant('viza_data.loyalty_warning'), messageType: 'WARNING', showIcon: true }
        const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
          disableClose: true,
          hasBackdrop: true,
          width: SessionStorage.IsMobile ? '100%' : '27%',
          maxWidth: '95vw',
          data: messageData
        })
      }

      if (this.dataFields.find(item => item.DataCode == "EMAIL").DataNature == "N"
        && this.dataFields.find(item => item.DataCode == "PLATE_NUMBER").DataNature == "N"
        && this.dataFields.find(item => item.DataCode == "PHONE").DataNature == "N"
        && this.dataFields.find(item => item.DataCode == "SIGNATURE").DataNature == "N") {
        this.hasAdditionalDataFields = false
      } else {
        this.hasAdditionalDataFields = true;
      }

      if (this.dataFields.find(item => item.DataCode == "CITY").DataNature !== "M") {
        this.addressGroup.controls["City"].removeValidators(Validators.required);
      }
      if (this.dataFields.find(item => item.DataCode == "ADDRESS").DataNature !== "M") {
        this.addressGroup.controls["StreetAddress"].removeValidators(Validators.required);
      }

      if (SessionStorage.MrzData !== undefined) {
        const nationality = this.countries.find(item => item.Id3 == SessionStorage.MrzData?.Nationality)
        if (!nationality) {
          let messageData: GenericMessage = { messageText: this.translate.instant('viza_data.false_nationality_alert'), messageType: 'WARNING', showIcon: true }
          const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            width: "auto",
            data: messageData
          })
        }
      }


      this.loaded = true;
      this.spinnerService.setSpinnerVisibility(false)
    })

  }
  ngAfterViewInit(): void {

  }

  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  sendVizaData() {

    if (LocalStorage.IsTabletMode) {
      if (LocalStorage.OperationMode == "VIP") {
        if (SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_ONLY) {
          if (SessionStorage.GuestAge == 'u14') {
            this.sendVizadataWithoutMrz()
          } else {
            this.sendVizadataWithMrz()
          }
        } else {
          this.sendVizadataWithoutMrz()
        }
      } else {
        if (SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_ONLY) {

          if (SessionStorage.GuestAge == 'u14') {
            this.sendGroupDataWithoutMrz()
          } else {
            this.sendGroupDataWithMrz()
          }

        } else {
          this.sendGroupDataWithoutMrz()
        }
      }
    } else {
      if (SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_ONLY) {
        if (SessionStorage.GuestAge == 'u14') {
          this.sendVizadataWithoutMrz()
        } else {
          this.sendVizadataWithMrz()
        }
      } else {
        this.sendVizadataWithoutMrz()
      }
    }
  }

  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }

  }

  // groups ---------------
  sendGroupDataWithMrz() {
    let genderId: string;
    let documentTypeId: string;
    let genderIdManual: string

    switch (SessionStorage.MrzData?.Sex) {
      case "M":
        genderId = "male";
        break;
      case "F":
        genderId = "female";
        break;
      default:
        genderId = "unknown";
    }

    switch (this.commonGroup.controls['Sex'].value) {
      case "M":
        genderIdManual = "male";
        break;
      case "F":
        genderIdManual = "female";
        break;
      default:
        genderIdManual = "unknown";
    }

    if (SessionStorage.MrzData.DocumentType.includes('TD1') || SessionStorage.MrzData.DocumentType.includes('TD2')) {
      documentTypeId = 'I'
    }
    if (SessionStorage.MrzData.DocumentType.includes('TD3')) {
      documentTypeId = 'P'
    }

    const nationality = this.countries.find(item => item.Id3 == SessionStorage.MrzData?.Nationality) ?
      this.countries.find(item => item.Id3 == SessionStorage.MrzData?.Nationality).Id : this.countries[0].Id

    let data: GroupVizaData = {
      Group3pId: LocalStorage.Group3Pid,
      Hotel3pId: LocalStorage.Hotel3Pid,
      Device3pId: LocalStorage.Device3PId,
      Address: {
        City: this.addressGroup.controls["City"].value,
        Country: nationality,
        PostalCode: this.addressGroup.controls["PostalCode"].value,
        StreetAddress: this.addressGroup.controls["StreetAddress"].value,

      },
      ScannedData: {
        Birthdate: DateHelper.FormatDate(SessionStorage.MrzData?.DateOfBirth),
        BirthPlace: '',
        DateOfEntry: '',
        DocumentId: SessionStorage.MrzData?.DocumentNumber,
        DocumentType: documentTypeId,
        FirstName: SessionStorage.MrzData?.GivenNames,
        FirstNameAtBirth: '',
        Gender: genderId,
        LastName: SessionStorage.MrzData?.Surname,
        LastNameAtBirth: '',
        MothersFirstName: '',
        MothersLastName: '',
        Nationality: nationality,
        Number: '',
        PlaceOfEntry: ''
      },
      ManualData: {
        Birthdate: this.birthDateComponent.selectedDateValue(), // this.commonGroup.controls['BirthDate'].value,
        BirthPlace: this.commonGroup.controls['BirthPlace'].value,
        DateOfEntry: this.visaRequired() ? this.dateOfEntryComponent.selectedDateValue() : '',
        DocumentId: this.commonGroup.controls['DocumentId'].value,
        DocumentType: this.commonGroup.controls['DocumentType'].value,
        FirstName: this.commonGroup.controls['LastName'].value,
        FirstNameAtBirth: this.commonGroup.controls['LastNameAtBirth'].value,
        Gender: genderIdManual,
        LastName: this.commonGroup.controls['FirstName'].value,
        LastNameAtBirth: this.commonGroup.controls['FirstNameAtBirth'].value,
        MothersFirstName: this.commonGroup.controls['MothersLastName'].value,
        MothersLastName: this.commonGroup.controls['MothersFirstName'].value,
        Nationality: nationality,
        Number: this.visaRequired() ? this.visaRequiredGroup.controls['VizaNumber'].value : '',
        PlaceOfEntry: this.visaRequired() ? this.visaRequiredGroup.controls['PlaceOfEntry'].value : ''
      }
    }

    this.vizaDataService.SendGroupVizaData(data).subscribe({
      next: (result => {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('additional_data.details_save_ok'), messageType: 'INFORMATION', showIcon: false }
        this.showResultDialog(messageData, false)
      }),
      error(err) {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: false }
        this.showResultDialog(messageData, true)
      },
    })

  }
  sendGroupDataWithoutMrz() {
    let genderIdManual: string
    switch (this.commonGroup.controls['Sex'].value) {
      case "M":
        genderIdManual = "male";
        break;
      case "F":
        genderIdManual = "female";
        break;
      default:
        genderIdManual = "unknown";
    }

    let data: GroupVizaData = {
      Group3pId: LocalStorage.Group3Pid,
      Hotel3pId: LocalStorage.Hotel3Pid,
      Device3pId: LocalStorage.Device3PId,
      Address: {
        City: this.addressGroup.controls["City"].value,
        Country: this.countries.find(item => item.Id3 == this.addressGroup.controls['Country'].value).Id,
        PostalCode: this.addressGroup.controls["PostalCode"].value,
        StreetAddress: this.addressGroup.controls["StreetAddress"].value,

      },
      ScannedData: {
        Birthdate: '',
        BirthPlace: '',
        DateOfEntry: '',
        DocumentId: '',
        DocumentType: '',
        FirstName: '',
        FirstNameAtBirth: '',
        Gender: '',
        LastName: '',
        LastNameAtBirth: '',
        MothersFirstName: '',
        MothersLastName: '',
        Nationality: '',
        Number: '',
        PlaceOfEntry: ''
      },
      ManualData: {
        Birthdate: this.birthDateComponent.selectedDateValue(), // this.commonGroup.controls['BirthDate'].value,
        BirthPlace: this.commonGroup.controls['BirthPlace'].value,
        DateOfEntry: this.visaRequired() ? this.dateOfEntryComponent.selectedDateValue() : '',
        DocumentId: this.commonGroup.controls['DocumentId'].value,
        DocumentType: this.commonGroup.controls['DocumentType'].value,
        FirstName: this.commonGroup.controls['LastName'].value,
        FirstNameAtBirth: this.commonGroup.controls['LastNameAtBirth'].value,
        Gender: genderIdManual,
        LastName: this.commonGroup.controls['FirstName'].value,
        LastNameAtBirth: this.commonGroup.controls['FirstNameAtBirth'].value,
        MothersFirstName: this.commonGroup.controls['MothersLastName'].value,
        MothersLastName: this.commonGroup.controls['MothersFirstName'].value,
        Nationality: this.countries.find(item => item.Id3 == this.commonGroup.controls['Nationality'].value).Id,
        Number: this.visaRequired() ? this.visaRequiredGroup.controls['VizaNumber'].value : '',
        PlaceOfEntry: this.visaRequired() ? this.visaRequiredGroup.controls['PlaceOfEntry'].value : ''
      }

    }
    this.vizaDataService.SendGroupVizaData(data).subscribe({
      next: (result => {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('additional_data.details_save_ok'), messageType: 'INFORMATION', showIcon: false }
        this.showResultDialog(messageData, false)
      }),
      error(err) {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: false }
        this.showResultDialog(messageData, true)
      },
    })
  }

  // email +VIP

  sendVizadataWithoutMrz() {
    let genderId: string;
    let documentTypeId: string;
    let genderIdManual: string

    switch (this.commonGroup.controls['Sex'].value) {
      case "M":
        genderIdManual = "male";
        break;
      case "F":
        genderIdManual = "female";
        break;
      default:
        genderIdManual = "unknown";
    }

    let data: VizaData = {
      GuestStayUuId: SessionStorage.SelectedGuestData.GuestStayUuId,
      Hotel3pId: SessionStorage.ReservationInfo.Hotel3pId,
      Address: {
        City: this.addressGroup.controls["City"].value,
        Country: this.countries.find(item => item.Id3 == this.addressGroup.controls['Country'].value).Id,
        PostalCode: this.addressGroup.controls["PostalCode"].value,
        StreetAddress: this.addressGroup.controls["StreetAddress"].value,
      },
      ScannedData: this.vipScannedDataPart(),
      ManualData: {
        Birthdate: this.birthDateComponent.selectedDateValue(), // this.commonGroup.controls['BirthDate'].value,
        BirthPlace: this.commonGroup.controls['BirthPlace'].value,
        DateOfEntry: this.visaRequired() ? this.dateOfEntryComponent.selectedDateValue() : '',
        DocumentId: this.commonGroup.controls['DocumentId'].value,
        DocumentType: this.commonGroup.controls['DocumentType'].value,
        FirstName: this.commonGroup.controls['LastName'].value,
        FirstNameAtBirth: this.commonGroup.controls['LastNameAtBirth'].value,
        Gender: genderIdManual,
        LastName: this.commonGroup.controls['FirstName'].value,
        LastNameAtBirth: this.commonGroup.controls['FirstNameAtBirth'].value,
        MothersFirstName: this.commonGroup.controls['MothersLastName'].value,
        MothersLastName: this.commonGroup.controls['MothersFirstName'].value,
        Nationality: this.countries.find(item => item.Id3 == this.commonGroup.controls['Nationality'].value).Id,
        Number: this.visaRequired() ? this.visaRequiredGroup.controls['VizaNumber'].value : '',
        PlaceOfEntry: this.visaRequired() ? this.visaRequiredGroup.controls['PlaceOfEntry'].value : ''
      }
    }
    this.vizaDataService.SendVizaData(data).subscribe({
      next: (result => {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('additional_data.details_save_ok'), messageType: 'INFORMATION', showIcon: false }
        this.showResultDialog(messageData, false)
      }),
      error(err) {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: false }
        this.showResultDialog(messageData, true)
      },
    })

  }

  sendVizadataWithMrz() {
    let genderId: string;
    let documentTypeId: string;
    let genderIdManual: string

    switch (SessionStorage.MrzData?.Sex) {
      case "M":
        genderId = "male";
        break;
      case "F":
        genderId = "female";
        break;
      default:
        genderId = "unknown";
    }

    switch (this.commonGroup.controls['Sex'].value) {
      case "M":
        genderIdManual = "male";
        break;
      case "F":
        genderIdManual = "female";
        break;
      default:
        genderIdManual = "unknown";
    }

    if (SessionStorage.MrzData) {
      if (SessionStorage.MrzData.DocumentType.includes('TD1') || SessionStorage.MrzData.DocumentType.includes('TD2')) {
        documentTypeId = 'I'
      }
      if (SessionStorage.MrzData.DocumentType.includes('TD3')) {
        documentTypeId = 'P'
      }

    }
    const nationality = this.countries.find(item => item.Id3 == SessionStorage.MrzData?.Nationality) ?
      this.countries.find(item => item.Id3 == SessionStorage.MrzData?.Nationality).Id : this.countries[0].Id
    let data: VizaData = {
      GuestStayUuId: SessionStorage.SelectedGuestData.GuestStayUuId,
      Hotel3pId: SessionStorage.ReservationInfo.Hotel3pId,
      Address: {
        City: this.addressGroup.controls["City"].value,
        Country: this.countries.find(item => item.Id3 == this.addressGroup.controls['Country'].value).Id,
        PostalCode: this.addressGroup.controls["PostalCode"].value,
        StreetAddress: this.addressGroup.controls["StreetAddress"].value,

      },
      // MRZ hiányában VIP tablet módban a recepción beolvasott adat megy
      ScannedData: !SessionStorage.MrzData && this.vipScannedData ? this.vipScannedDataPart() : {
        Birthdate: DateHelper.FormatDate(SessionStorage.MrzData?.DateOfBirth),
        BirthPlace: '',
        DateOfEntry: '',
        DocumentId: SessionStorage.MrzData?.DocumentNumber,
        DocumentType: SessionStorage.MrzData?.DocumentType,
        FirstName: SessionStorage.MrzData?.GivenNames,
        FirstNameAtBirth: '',
        Gender: genderId,
        LastName: SessionStorage.MrzData?.Surname,
        LastNameAtBirth: '',
        MothersFirstName: '',
        MothersLastName: '',
        Nationality: nationality,
        Number: '',
        PlaceOfEntry: ''
      },
      ManualData: {
        Birthdate: this.birthDateComponent.selectedDateValue(), // this.commonGroup.controls['BirthDate'].value,
        BirthPlace: this.commonGroup.controls['BirthPlace'].value,
        DateOfEntry: this.visaRequired() ? this.dateOfEntryComponent.selectedDateValue() : '',
        DocumentId: this.commonGroup.controls['DocumentId'].value,
        DocumentType: this.commonGroup.controls['DocumentType'].value,
        FirstName: this.commonGroup.controls['LastName'].value,
        FirstNameAtBirth: this.commonGroup.controls['LastNameAtBirth'].value,
        Gender: genderIdManual,
        LastName: this.commonGroup.controls['FirstName'].value,
        LastNameAtBirth: this.commonGroup.controls['FirstNameAtBirth'].value,
        MothersFirstName: this.commonGroup.controls['MothersLastName'].value,
        MothersLastName: this.commonGroup.controls['MothersFirstName'].value,
        Nationality: this.countries.find(item => item.Id3 == this.commonGroup.controls['Nationality'].value).Id,
        Number: this.visaRequired() ? this.visaRequiredGroup.controls['VizaNumber'].value : '',
        PlaceOfEntry: this.visaRequired() ? this.visaRequiredGroup.controls['PlaceOfEntry'].value : ''
      }
    }


    this.vizaDataService.SendVizaData(data).subscribe({
      next: (result => {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('additional_data.details_save_ok'), messageType: 'INFORMATION', showIcon: false }
        this.showResultDialog(messageData, false)
      }),
      error(err) {
        let messageData: GenericMessage
        messageData = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: false }
        this.showResultDialog(messageData, true)
      },
    })

  }




  onKeyNationality(event) {
    this.filteredCountry = this.search(event.target.value);
  }
  onKeyCountry(event) {
    this.filteredCountry = this.search(event.target.value);
  }

  search(value: string) {
    let filter = value.toLowerCase()
    return this.countries.filter(country => country.Name.toLocaleLowerCase().startsWith(filter));
  }
  //#endregion =================================================================================================================

  //#region =============== Validation =========================================================================================
  visaRequired() {
    if (this.countries.length > 0 && this.commonGroup.controls["Nationality"].value !== '') {
      const selectedCountry = this.countries.find(item => item.Id3 == this.commonGroup.controls["Nationality"].value);
      return selectedCountry?.IsEu === 'FALSE';
    }
    return false;
  }

  allFieldsValid(): boolean {
    const commonGroupValid = this.commonGroup.valid;
    const visaGroupValid = !this.visaRequired() || this.visaRequiredGroup.valid;

    if (!this.hasAdditionalDataFields) {
      return commonGroupValid && visaGroupValid && this.addressGroup.valid && this.acceptConditionsGroup.controls["Accept"].value == true;
    }
    return commonGroupValid && visaGroupValid && this.addressGroup.valid;
  }


  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  fieldMustShow(dataCode: string): boolean {
    const item = this.dataFields.find(item => item.DataCode == dataCode);
    return (item.DataNature == 'N' ? false : true)
  }

  requiredChar(data_code: string): string {
    const field = this.dataFields.find(item => item.DataCode == data_code);
    return field.DataNature == "M" ? '*' : ''
  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  showResultDialog(messageData: GenericMessage, hasError: boolean) {
    this.modalVisible = true
    const okRef = this.dialog.open(GenericMessageDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      maxWidth: "auto",
      data: messageData
    })

    okRef.afterClosed().subscribe(data => {
      if (!hasError) {
        if (LocalStorage.IsTabletMode && LocalStorage.OperationMode !== 'VIP') {
          this.router.navigateByUrl('/startcheckin')
        } else {
          if (this.hasAdditionalDataFields) {
            this.router.navigateByUrl('/additionaldata')
          } else {
            this.router.navigateByUrl('/checkinstatus')
          }
        }
      }
    })
  }

  async loadVipGuestData() {
    const guestStayUuId = SessionStorage.SelectedGuestData?.GuestStayUuId
    if (!guestStayUuId) {
      return
    }

    let data: VizaData
    try {
      data = await firstValueFrom(this.reservationService.GetVipTableGuestDatas(LocalStorage.Hotel3Pid, guestStayUuId))
    } catch {
      return
    }

    const vip = data?.ScannedData
    if (!vip) {
      return
    }
    this.vipScannedData = vip

    let sex = ''
    switch (vip.Gender) {
      case "male":
        sex = "M";
        break;
      case "female":
        sex = "F";
        break;
    }

    // backend: YYYY-MM-DD, date-selector: YYMMDD
    const birthDate = (vip.Birthdate ?? '').replace(/\D/g, '')

    const name = this.splitName(vip.LastName, vip.FirstName)
    const nameAtBirth = this.splitName(vip.LastNameAtBirth, vip.FirstNameAtBirth)
    const mothersName = this.splitName(vip.MothersLastName, vip.MothersFirstName)

    // a FirstName control a vezetéknév, a LastName a keresztnév (lásd küldés)
    this.commonGroup.patchValue({
      BirthDate: birthDate.length == 8 ? birthDate.substring(2) : '',
      FirstName: name.lastName,
      LastName: name.firstName,
      FirstNameAtBirth: nameAtBirth.lastName,
      LastNameAtBirth: nameAtBirth.firstName,
      BirthPlace: vip.BirthPlace ?? '',
      Nationality: this.countries.find(item => item.Id == vip.Nationality)?.Id3 ?? '',
      MothersFirstName: mothersName.lastName,
      MothersLastName: mothersName.firstName,
      DocumentType: vip.DocumentType ?? '',
      DocumentId: vip.DocumentId ?? '',
      Sex: sex
    })

    if (data.Address) {
      this.addressGroup.patchValue({
        Country: this.countries.find(item => item.Id == data.Address.Country)?.Id3 ?? '',
        PostalCode: data.Address.PostalCode ?? '',
        City: data.Address.City ?? '',
        StreetAddress: data.Address.StreetAddress ?? ''
      })
    }
  }

  // a recepción beolvasott okmányadat ScannedData-ként; ha nincs (nem VIP tablet mód), üres
  private vipScannedDataPart(): VizaPart {
    const vip = this.vipScannedData
    return {
      Birthdate: vip?.Birthdate ?? '',
      BirthPlace: vip?.BirthPlace ?? '',
      DateOfEntry: '',
      DocumentId: vip?.DocumentId ?? '',
      DocumentType: vip?.DocumentType ?? '',
      FirstName: vip?.FirstName ?? '',
      FirstNameAtBirth: vip?.FirstNameAtBirth ?? '',
      Gender: vip?.Gender ?? '',
      LastName: vip?.LastName ?? '',
      LastNameAtBirth: vip?.LastNameAtBirth ?? '',
      MothersFirstName: vip?.MothersFirstName ?? '',
      MothersLastName: vip?.MothersLastName ?? '',
      Nationality: vip?.Nationality ?? '',
      Number: '',
      PlaceOfEntry: ''
    }
  }

  // "Vezetéknév Keresztnév" -> az első szóköznél bontva; a FRO csupa nagybetűvel adja, title case-re alakítjuk
  splitName(lastName: string, firstName: string): { lastName: string, firstName: string } {
    const fullName = HwUtils.toTitleCase([lastName, firstName].map(item => item?.trim()).filter(item => item).join(' '))
    const spaceIndex = fullName.indexOf(' ')
    if (spaceIndex < 0) {
      return { lastName: fullName, firstName: '' }
    }
    return { lastName: fullName.substring(0, spaceIndex), firstName: fullName.substring(spaceIndex + 1).trim() }
  }

  controlValueChanged(controlName: string) {
    //this.commonGroup.controls["BirthDate"].updateValueAndValidity();
    // 14 év alatti , nem kell warning
    if ((SessionStorage.GuestAge == 'u14') || (!SessionStorage.MrzData)) {
      return
    } else {
      this.showModifyWarning(controlName)
      return
    }
  }





  showModifyWarning(controlName: string) {
    let messageData: GenericMessage;
    messageData = { messageText: this.translate.instant('viza_data.field_modify_warning'), messageType: 'WARNING', showIcon: true }
    if (!this.mrzCcontrols.find(control => control.ControlName == controlName).Touched) {
      this.dialog.open(YesNoDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: messageData
      }).afterClosed().subscribe(data => {
        if (data) {
          this.mrzCcontrols.find(control => control.ControlName == controlName).Touched = true;
        }
        this.birthDateComponent.closeCombo();
        this.documentType.close();
      })
    }
  }


  //#endregion =================================================================================================================
}

export function dateValidator(control: AbstractControl): ValidationErrors | null {
  let longDate: string = ""
  if (control.value.toString() == '') {
    return { invalidDate: true }
  }
  if (control.value.length == 6) {
    const y = control.value.substring(0, 2)

    let prefix = parseInt(y) > 23 ? '19' : '20';   // - ha az nagyobb mint 23, akkor az év 19xx  - ha kisebb, akkor az év 20xx
    longDate = prefix + control.value
  } else if (control.value.length == 8) {
    longDate = control.value
  }

  if (dayjs(dayjs(longDate).format("YYYYMMDD")).isAfter(dayjs())) {
    return { invalidDate: true }
  } else {
    return null;
  }

}
class MrzControl {
  ControlName: string;
  Touched: boolean;
}
